import { gql } from '@apollo/client';

export const GET_ORG_CHAT_SETTINGS = gql`
  query GetOrgChatSettings {
    tm {
      tenant {
        config {
          chatEnabled
          chatAutoChannelProgram
          chatAutoChannelActivity
          chatAutoChannelRole
          chatAutoChannelRoster
        }
      }
    }
  }
`;
